module.exports = __webpack_public_path__ + "img/3.62ce28e4.png";